module.exports = __webpack_public_path__ + "static/media/radial_plan_inversed.1ebfcfa2.png";